import Row from '@components/row'
import CardHeading from '@commons/headings/card'
import Empty from '@commons/empty'
import Column from '@components/column'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
import { Fragment, useEffect } from 'react'
import { StyleGrid } from './style'
import InstantAppointmentQueueLoader from '@commons/cards/instantAppointmentQueue/loader'
import InstantAppointmentQueueCard from '@commons/cards/instantAppointmentQueue'
const List = () => {
  const { data: appointments, loading } = useSelector(
    (state: any) => state.queueAppointments,
  )

  const fetchData = async () => {
    await Appointment.list({
      params: {
        isPagination: false,
        status: 'Queue',
        isInstant: true,
      },
      state: 'queueAppointments',
      action: 'set',
    })
  }

  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])
  return (
    <Column rowGap={15}>
      <Row justifyContent="space-between">
        <CardHeading tc="primary" title="Queue" />
      </Row>

      {!!loading ? (
        <StyleGrid>
          {Array(5)
            ?.fill(0)
            ?.map((_: any, index: number) => {
              return (
                <Fragment key={index}>
                  <InstantAppointmentQueueLoader />
                </Fragment>
              )
            })}
        </StyleGrid>
      ) : (
        <>
          {!!appointments?.length ? (
            <StyleGrid>
              {appointments?.map((appointment: any) => {
                return (
                  <Fragment key={appointment?.id}>
                    <InstantAppointmentQueueCard appointment={appointment} />
                  </Fragment>
                )
              })}
            </StyleGrid>
          ) : (
            <Empty />
          )}
        </>
      )}
    </Column>
  )
}

export default List
